import { render, staticRenderFns } from "./CompanyDescriptionWidget.vue?vue&type=template&id=4ea96438&scoped=true"
import script from "./CompanyDescriptionWidget.vue?vue&type=script&lang=js"
export * from "./CompanyDescriptionWidget.vue?vue&type=script&lang=js"
import style0 from "./CompanyDescriptionWidget.vue?vue&type=style&index=0&id=4ea96438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea96438",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Card: require('/skade-pwa/components/ui/atom/Card.vue').default})
